// extracted by mini-css-extract-plugin
module.exports = {"root":"LearnMoreStrip_root__3f02z"};